import { Component, OnDestroy, OnInit } from '@angular/core';
import { TableComponent } from "../../../shared/component/table/table.component";
import { ApiCallsService } from '../../../shared/services/api-calls.service';
import { AgGridTableService } from '../../../shared/services/ag-grid.service';
import { DestroyableComponent } from '../../../shared/services/destroyable.component';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-gateway-tabular',
  imports: [TableComponent],
  templateUrl: './gateway-tabular.component.html',
  styleUrl: './gateway-tabular.component.scss'
})
export class GatewayTabularComponent extends DestroyableComponent implements OnInit,OnDestroy {
  siteid: string | null;

  constructor( private apiservice:ApiCallsService,private table:AgGridTableService, private route: ActivatedRoute){
    super()   
  }
  ExportFileName:string = ''
  providerName: string = '';
  status: string = '';
  ShowDLFilter:boolean = true
ngOnInit(): void {
      this.route.queryParamMap
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        /* 🔑 Resolve siteId */
        const encodedId =
          params.get('siteid') || localStorage.getItem('site_idLogin');
        
        this.siteid = encodedId ? atob(encodedId) : null;})
  this.route.queryParams.subscribe(params => {
    this.providerName = params['provider'] || '';
    this.status = params['status'] || '';


    if (this.providerName && this.status) {
      // Query params are present
      this.fetchData('gateway');
      this.ShowDLFilter = false;
    } else {
      // No query params
      this.fetchData('site_wise');
      this.ShowDLFilter = true;
    }
  });
}


fetchData(dataType: string = '') {
  switch (dataType) {
    case 'site_wise':
      this.ExportFileName = 'Gateway Data'
      this.apiservice.getDataloggerList(this.siteid||'').subscribe(response => {
        this.table.processTableData(response);
            setTimeout(() => {
  
    this.table.get_particular_row('','service_provider')
    setTimeout(() => {
      this.table.get_particular_row('','connected')
    }, 0);
  }, 100);
      });
      break;
    case 'gateway':
      this.ExportFileName = 'Gateway Detailed Data'
      this.table.processTableData([])
      this.apiservice.getDataloggerListDetailed(this.siteid||'').subscribe(response => {
        this.table.processTableData(response, 'site_name');
          setTimeout(() => {
  
    this.table.get_particular_row(this.providerName,'service_provider')
    setTimeout(() => {
      if (this.status) {
        this.table.get_particular_row(this.status==='connected'?"Yes":"No",'connected')
      }
    }, 100);
  }, 100);
      });
      break;
    default:
      console.warn('Unknown dataType:', dataType);
      break;
  }

  
}

override ngOnDestroy(): void {
    setTimeout(() => {
  
    this.table.get_particular_row('','service_provider')
    setTimeout(() => {
      this.table.get_particular_row('','connected')
    }, 100);
  }, 100);
}

}
